/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportVendorsMutationVariables = Types.Exact<{
  object: Types.ImportVendorsInput;
}>;

export type ImportVendorsMutation = { __typename?: 'mutation_root'; import_vendors: string };

export const ImportVendorsDocument = `
    mutation ImportVendors($object: ImportVendorsInput!) {
  import_vendors(object: $object)
}
    ` as string & TypedDocumentNode<ImportVendorsMutation, ImportVendorsMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportVendors: build.mutation<ImportVendorsMutation, ImportVendorsMutationVariables>({
      query: (variables) => ({ document: ImportVendorsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportVendorsMutation } = injectedRtkApi;
